import moment from "moment"
import { TaskDeadline, TaskStatus } from "./TaskIndicators"

export const TaskOneMovil = ({ task, from = 'tasklist' }) => {

    const {
        id,
        nombre,
        proyecto,
        hito_name,
        hito_orden,
        task_name,
        fecha_fin,
        tipo,
        total_subtareas_completadas = 0,
        total_subtareas = 0,
        id_origen,
        responsable,
        estado
    } = task

    return (
        <div key={id} className='row p-project-list-mode tasks-mobile-card'>
            <div className='flex flex-column'>
                <span className='text-[#595759] text-[16px] font-semibold'>{nombre}</span>

                <div className='text-gray-500 uppercase text-[12px]'>
                    {hito_name &&
                        <span>hito {hito_orden}: {hito_name}</span>
                    }
                    {tipo === 'subtask' &&
                        <>
                            {hito_name && <span className='text-[12px]'>{' > '}</span>}
                            <span>tarea: {task_name}</span>
                        </>
                    }
                </div>

                {id_origen ?
                    <div className='mt-2 flex items-center text-gray-500'>
                        <i className="bi bi-folder2 text-[12px] text-[#8E24AA]"></i>
                        <span className='ms-1 uppercase'>{proyecto}</span>
                    </div>
                    :
                    'Tarea general'
                }


                {from === "tasklist" ? (
                    <div className="tasks-mobile-meta">
                        <TaskDeadline date={fecha_fin} status={estado} />
                        <TaskStatus status={estado} />
                        {responsable && <span><i className="bi bi-person" aria-hidden="true" /> {responsable}</span>}
                    </div>
                ) : (
                    <span className="mt-2 text-[#848383] flex justify-start ">
                        <i className="bi bi-calendar-event text-[12px]"></i>
                        {fecha_fin ?
                            ((moment(fecha_fin).format('YYYY-MM-DD') < moment(new Date()).format('YYYY-MM-DD')) ?
                                <span className='pm-box-fecha ms-1 text-red-500'>{moment(fecha_fin).format('D MMM YYYY')}</span> :
                                ((moment(fecha_fin).format('YYYY-MM-DD') === moment(new Date()).format('YYYY-MM-DD')) ?
                                    <span className='pm-box-fecha ms-1 text-green-500'>{moment(fecha_fin).format('D MMM YYYY')}</span> :
                                    <span className='pm-box-fecha ms-1'>{moment(fecha_fin).format('D MMM YYYY')}</span>
                                )
                            )
                            :
                            <span className="ms-1">Sin fecha límite</span>
                        }
                        {responsable &&
                            <span className="ms-3">
                                <i className="bi bi-person"></i>
                                <label className="capitalize ms-1">{responsable || 'Sin responsable'}</label>
                            </span>
                        }
                    </span>
                )}
                {total_subtareas > 0 ?
                    <span style={{ marginTop: '10px' }}>{total_subtareas_completadas} de {total_subtareas} subtareas</span>
                    : ''
                }
            </div>
        </div >
    )
}